// SPDX-FileCopyrightText: © 2023 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

// eslint-disable-next-line import/no-extraneous-dependencies
import { createStore } from "@stencil/store";

const { state } = createStore({
  item: "",
  tab: "",
});

export default state;
